import React from 'react';
import { FaSpinner } from "react-icons/fa";


const Cargando = () => {
  return (
        <div className="sin-registros">
            <FaSpinner className="rotar icon-cargando" />
        </div>
  );
};

export default Cargando;
